import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReceiptCheck"><Path d="M9.5 13.5H14.5M9.75 9.10005L11.1 10.4501L14.25 7.30006M4.5 2.5V21.25L8.25 19.25L12 21.25L15.75 19.25L19.5 21.25V2.5H4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconReceiptCheck;
